import React from 'react';
export const MegaMenuCard = ({ title, description, imageSrc, url }) => {
    return (React.createElement("a", { href: url, className: "mega-menu-card" },
        imageSrc && React.createElement("img", { className: "mega-menu-card__image", src: imageSrc }),
        React.createElement("div", { className: "mega-menu-card__content" },
            React.createElement("div", { className: "mega-menu-card__title" }, title),
            description && (React.createElement("div", { className: "mega-menu-card__description" }, description)),
            React.createElement("svg", { className: "mega-menu-card__arrow", role: "presentation", width: 24, height: 32 },
                React.createElement("use", { xlinkHref: "#square-arrow-right" })))));
};
